import { TextField } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import { change } from '../../../store/actions/account.action'

const Pay2m = (props) => {
    const dispatch = useDispatch();
    const { account, error } = useSelector(state => state.accountReducer)

    return (
        <>
            <div className="mb-3">
                <label className="label-custom bs-color-b">Client ID</label>
                <TextField
                    error={(error.pay2m_client_id) && true}
                    value={account.pay2m_client_id || ''}
                    onChange={e => {
                        dispatch(change({pay2m_client_id: e.target.value}))
                        if (error.pay2m_client_id && delete error.pay2m_client_id);
                    }}
                />

                {(error.pay2m_client_id) &&
                    <strong className="text-danger">{error.pay2m_client_id[0]}</strong>
                }
            </div>

            <div className="mb-3">
                <label className="label-custom bs-color-b">Client Secret</label>
                <TextField
                    disabled={(props.id)}
                    error={(error.pay2m_client_secret) && true}
                    value={account.pay2m_client_secret || ''}
                    onChange={e => {
                        dispatch(change({pay2m_client_secret: e.target.value}))
                        if (error.pay2m_client_secret && delete error.pay2m_client_secret);
                    }}
                />

                {(error.pay2m_client_secret) &&
                    <strong className="text-danger">{error.pay2m_client_secret[0]}</strong>
                }
            </div>
        </>
    )
}


export default Pay2m